import { ReactNode } from 'react';

import { useResponsive } from 'shared/hooks';

import { Centered, Container, Content, Sidebar } from './FeedLayout.styles';

export interface FeedLayoutProps {
  className?: string;

  /** Content for the layout. */
  children: ReactNode;
  /** Sidebar for the layout. */
  sidebar?: ReactNode;
}

/**
 * Layout for a content-sidebar arrangement for feed-related pages.
 */
export function FeedLayout(props: FeedLayoutProps) {
  const { isMobile } = useResponsive();

  return (
    <Container className={props.className}>
      <Centered>
        <Content>{props.children}</Content>
      </Centered>

      {!isMobile && <Sidebar>{props.sidebar}</Sidebar>}
    </Container>
  );
}
